import React from 'react';
import NextLink from 'next/link';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';

import { WidgetListItem } from '@/core/interfaces/common';

import { colors } from '@/utils/constants';

const Container = styled(Grid)`
  max-width: 600px;
`;

const ListWrapper = styled.ul`
  margin: 20px 40px;
`;

const EmptyItemWrapper = styled.li`
  width: 100%;
  padding: 10px;
  text-align: center;
`;

const WidgetItemWrapper = styled.li`
  width: 100%;
  border-bottom: 1px solid ${colors.borderTransparentGray};
  padding: 10px;
  text-align: center;
  cursor: pointer;

  &:hover {
    border-bottom: 0;
    background-color: ${colors.borderTransparentGray};
  }
`;

const Link = styled.a`
  color: inherit;
  text-decoration: none;

  &:hover,
  &:focus,
  &:active {
    color: inherit;
    text-decoration: none;
  }
`;

interface WidgetListProps {
  widgetList: Array<WidgetListItem>;
  useName: boolean;
}

export const WidgetList = ({
  widgetList, useName,
}: WidgetListProps) => {
  if (widgetList?.length) {
    return (
      <Container
        className="muster-action-center-container"
      >
        <ListWrapper
          className="muster-action-center-list"
        >
          {widgetList?.map(({
            name,
            title,
            uuid,
          }) => (
            <WidgetItemWrapper
              key={uuid}
              className="muster-action-center-item"
            >
              <NextLink
                href={`/${uuid}`}
                passHref
              >
                <Link
                  target="_blank"
                  rel="noopener noreferrer"
                  className="muster-action-center-link"
                >
                  <h3
                    className="muster-action-center-title"
                  >
                    {useName ? name : title}
                  </h3>
                </Link>
              </NextLink>
            </WidgetItemWrapper>
          ))}
        </ListWrapper>
      </Container>
    );
  }

  return (
    <Container>
      <ListWrapper>
        <EmptyItemWrapper>
          <h3>
            There are no active campaigns
          </h3>
        </EmptyItemWrapper>
      </ListWrapper>
    </Container>
  );
};
